export const SET_OPTIONS = 'SET_OPTIONS';
